import axiosInstance from "./axiosInstance";
import { API_ENDPOINTS } from "../config/api";









export const authAPI = {
  login: (email, password) =>
    axiosInstance.post(API_ENDPOINTS.LOGIN, { email, password }),
  register: (userData) => axiosInstance.post(API_ENDPOINTS.REGISTER, userData),
  logout: () => axiosInstance.post(API_ENDPOINTS.LOGOUT),
  getProfile: () => axiosInstance.get(API_ENDPOINTS.USER_ME),
  updateProfile: (data) => axiosInstance.put(API_ENDPOINTS.USER_ME, data),
  uploadProfileImage: (formData) => {
    return axiosInstance.post(API_ENDPOINTS.USER_PROFILE_IMAGE, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  deleteProfileImage: () =>
    axiosInstance.delete(API_ENDPOINTS.USER_PROFILE_IMAGE),
};

export const userAPI = {
  createUserByAdmin: (userData) =>
    axiosInstance.post(API_ENDPOINTS.ADMIN_CREATE_USER, userData),
  create: (userData) =>
    axiosInstance.post(API_ENDPOINTS.ADMIN_CREATE_USER, userData),

  getAllUsers: (params) => axiosInstance.get(API_ENDPOINTS.USERS, { params }),
  getAll: (params) => axiosInstance.get(API_ENDPOINTS.USERS, { params }),

  getUserById: (id) => axiosInstance.get(`${API_ENDPOINTS.USERS}/${id}`),
  getById: (id) => axiosInstance.get(`${API_ENDPOINTS.USERS}/${id}`),

  updateUser: (id, data) =>
    axiosInstance.put(`${API_ENDPOINTS.USERS}/${id}`, data),
  update: (id, data) =>
    axiosInstance.put(`${API_ENDPOINTS.USERS}/${id}`, data),

  deleteUser: (id) => axiosInstance.delete(`${API_ENDPOINTS.USERS}/${id}`),
  delete: (id) => axiosInstance.delete(`${API_ENDPOINTS.USERS}/${id}`),

  suspend: (id) => axiosInstance.put(`${API_ENDPOINTS.USERS}/${id}/suspend`),

  verifyEmail: (id) =>
    axiosInstance.put(`${API_ENDPOINTS.USERS}/${id}/verify-email`),

  generateReferralCode: (id) =>
    axiosInstance.post(`${API_ENDPOINTS.USERS}/${id}/generate-referral-code`),

  approveVerification: (id) =>
    axiosInstance.post(`${API_ENDPOINTS.USERS}/${id}/approve-verification`),

  getDoctors: (params) => axiosInstance.get(API_ENDPOINTS.DOCTORS, { params }),

  getDoctorsBySpecialty: (specialty) => {
    return axiosInstance.get(`${API_ENDPOINTS.DOCTORS}/specialty/${specialty}`);
  },

  uploadImage: (userId, formData) => {
    return axiosInstance.post(
      `${API_ENDPOINTS.USERS}/${userId}/profile-image`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  },

  uploadProfileImage: (userId, formData) => {
    return axiosInstance.post(
      `${API_ENDPOINTS.USERS}/${userId}/profile-image`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  },
};

export const doctorAPI = {
  getAll: (params) =>
    axiosInstance.get(API_ENDPOINTS.DOCTORDETAILS, { params }),

  getById: (id) => axiosInstance.get(`${API_ENDPOINTS.DOCTORDETAILS}/${id}`),

  getByUserId: (userId) =>
    axiosInstance.get(`${API_ENDPOINTS.DOCTORDETAILS}/user/${userId}`),

  create: (data) => axiosInstance.post(API_ENDPOINTS.DOCTORDETAILS, data),

  update: (id, data) =>
    axiosInstance.put(`${API_ENDPOINTS.DOCTORDETAILS}/${id}`, data),

  updateByUserId: (userId, data) =>
    axiosInstance.put(`${API_ENDPOINTS.DOCTORDETAILS}/user/${userId}`, data),

  delete: (id) => axiosInstance.delete(`${API_ENDPOINTS.DOCTORDETAILS}/${id}`),

  uploadDocument: (id, data) =>
    axiosInstance.post(`${API_ENDPOINTS.DOCTORDETAILS}/${id}/documents`, data),

  getStats: (id) =>
    axiosInstance.get(`${API_ENDPOINTS.DOCTORDETAILS}/${id}/stats`),

  uploadImage: (userId, formData) => {
    return axiosInstance.post(
      `${API_ENDPOINTS.USERS}/${userId}/image`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
  },
};
export const appointmentAPI = {
  getAll: (params) => axiosInstance.get(API_ENDPOINTS.APPOINTMENTS, { params }),

  getById: (id) => axiosInstance.get(`${API_ENDPOINTS.APPOINTMENTS}/${id}`),

  create: (data) => axiosInstance.post(API_ENDPOINTS.APPOINTMENTS, data),

  update: (id, data) =>
    axiosInstance.put(`${API_ENDPOINTS.APPOINTMENTS}/${id}`, data),

  cancel: (id) => axiosInstance.put(API_ENDPOINTS.APPOINTMENT_CANCEL(id)),

  delete: (id) => axiosInstance.delete(`${API_ENDPOINTS.APPOINTMENTS}/${id}`),

  getByStatus: (status, params) => {
    return axiosInstance.get(`${API_ENDPOINTS.APPOINTMENTS}/status/${status}`, {
      params,
    });
  },

  getByDoctor: (doctorId, params) => {
    return axiosInstance.get(
      `${API_ENDPOINTS.APPOINTMENTS}/doctor/${doctorId}`,
      { params }
    );
  },

  getByPatient: (patientId, params) => {
    return axiosInstance.get(
      `${API_ENDPOINTS.APPOINTMENTS}/patient/${patientId}`,
      { params }
    );
  },

  confirm: (id) =>
    axiosInstance.put(`${API_ENDPOINTS.APPOINTMENTS}/${id}/confirm`),

  complete: (id, data) =>
    axiosInstance.put(`${API_ENDPOINTS.APPOINTMENTS}/${id}/complete`, data),

  getDoctorRevenue: (params) =>
    axiosInstance.get(`${API_ENDPOINTS.APPOINTMENTS}/doctor-revenue`, { params }),
};

export const labAPI = {
  getAll: (params) => axiosInstance.get(API_ENDPOINTS.LABS, { params }),

  getById: (id) => axiosInstance.get(`${API_ENDPOINTS.LABS}/${id}`),

  create: (data) => axiosInstance.post(API_ENDPOINTS.LABS, data),

  update: (id, data) => axiosInstance.put(`${API_ENDPOINTS.LABS}/${id}`, data),

  delete: (id) => axiosInstance.delete(`${API_ENDPOINTS.LABS}/${id}`),

  uploadLogo: (id, formData) => {
    return axiosInstance.post(API_ENDPOINTS.LAB_LOGO(id), formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  deleteLogo: (id) => axiosInstance.delete(API_ENDPOINTS.LAB_LOGO(id)),

  addLocation: (id, data) =>
    axiosInstance.post(API_ENDPOINTS.LAB_LOCATIONS(id), data),

  updateLocation: (id, locationId, data) => {
    return axiosInstance.put(
      `${API_ENDPOINTS.LAB_LOCATIONS(id)}/${locationId}`,
      data
    );
  },

  deleteLocation: (id, locationId) => {
    return axiosInstance.delete(
      `${API_ENDPOINTS.LAB_LOCATIONS(id)}/${locationId}`
    );
  },

  getByCity: (city) => {
    return axiosInstance.get(`${API_ENDPOINTS.LABS}/city/${city}`);
  },

  search: (searchTerm, params) => {
    return axiosInstance.get(`${API_ENDPOINTS.LABS}/search`, {
      params: { ...params, search: searchTerm },
    });
  },

  getActive: (params) => {
    return axiosInstance.get(`${API_ENDPOINTS.LABS}/active`, { params });
  },
};

export const labTestAPI = {
  getByLabAdmin: (labAdminId, params) => {
    return axiosInstance.get(`/lab-tests/${labAdminId}`, { params });
  },

  getById: (id) => {
    return axiosInstance.get(`/lab-tests/test/${id}`);
  },

  create: (data) => {
    return axiosInstance.post("/lab-tests", data);
  },
  getAll: (data) => {
    return axiosInstance.get("/lab-tests", data);
  },

  update: (id, data) => {
    return axiosInstance.put(`/lab-tests/${id}`, data);
  },

  delete: (id) => {
    return axiosInstance.delete(`/lab-tests/${id}`);
  },

  getCategories: (labAdminId) => {
    return axiosInstance.get(`/lab-tests/${labAdminId}/categories`);
  },

  getStats: (labAdminId) => {
    return axiosInstance.get(`/lab-tests/${labAdminId}/stats`);
  },

  addOrUpdatePricing: (testId, data) => {
    return axiosInstance.post(`/lab-tests/${testId}/pricing`, data);
  },

  removePricing: (testId, labPartnerId) => {
    return axiosInstance.delete(`/lab-tests/${testId}/pricing/${labPartnerId}`);
  },

  getFixedCategories: () => {
    return axiosInstance.get("/lab-tests/categories/fixed");
  },
};

export const labPartnerAPI = {
  getAll: (labAdminId) => {
    return axiosInstance.get(`/lab-partners/${labAdminId}`);
  },

  getById: (id) => {
    return axiosInstance.get(`/lab-partners/partner/${id}`);
  },

  create: (data) => {
    return axiosInstance.post("/lab-partners", data);
  },

  update: (id, data) => {
    return axiosInstance.put(`/lab-partners/${id}`, data);
  },

  delete: (id) => {
    return axiosInstance.delete(`/lab-partners/${id}`);
  },

  addLocation: (id, location) => {
    return axiosInstance.post(`/lab-partners/${id}/locations`, { location });
  },

  removeLocation: (id, location) => {
    return axiosInstance.delete(`/lab-partners/${id}/locations`, {
      data: { location },
    });
  },

  getStats: (labAdminId) => {
    return axiosInstance.get(`/lab-partners/${labAdminId}/stats`);
  },

  search: (labAdminId, searchTerm) => {
    return axiosInstance.get(`/lab-partners/${labAdminId}/search`, {
      params: { search: searchTerm },
    });
  },
};














export const testBookingAPI = {
  getAll: (params = {}) => axiosInstance.get("/test-bookings/lab-admin", { params }),
  getByPatient: (patientUserId, params = {}) => axiosInstance.get("/test-bookings/lab-admin", { params: { ...params, patientUserId } }),
  getByLabAdmin: (params = {}) => axiosInstance.get("/test-bookings/lab-admin", { params }),
  getById: id => axiosInstance.get(`/test-bookings/${id}`),
  create: data => axiosInstance.post("/test-bookings", data),
  updateStatus: (id, data) => axiosInstance.put(`/test-bookings/${id}/status`, data),
  markSampleCollected: (id, data) => axiosInstance.put(`/test-bookings/${id}/sample-collected`, data),
  uploadReport: (id, data) => axiosInstance.post(`/test-bookings/${id}/report`, data),
  assignTests: (id, data) => axiosInstance.put(`/test-bookings/${id}/assign-tests`, data),
  getStats: id => axiosInstance.get(`/test-bookings/lab-admin/${id}/stats`),
  getInstantQueries: id => axiosInstance.get(`/test-bookings/lab-admin/${id}/instant-queries`),
};

export const uploadAPI = {
  single: (file, folder = "general") => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("folder", folder);
    return axiosInstance.post(API_ENDPOINTS.UPLOAD_SINGLE, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  multiple: (files, folder = "general") => {
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));
    formData.append("folder", folder);
    return axiosInstance.post(API_ENDPOINTS.UPLOAD_MULTIPLE, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  delete: (fileUrl) => {
    return axiosInstance.delete(API_ENDPOINTS.UPLOAD_DELETE, {
      data: { fileUrl },
    });
  },

  uploadImage: (file) => uploadAPI.single(file, "images"),

  uploadDocument: (file) => uploadAPI.single(file, "documents"),

  uploadMedicalReport: (file) => uploadAPI.single(file, "medical-reports"),

  uploadPrescription: (file) => uploadAPI.single(file, "prescriptions"),
};

export const reportAPI = {
  getDashboardStats: () => axiosInstance.get("/reports/dashboard-stats"),

  getAppointmentStats: (params) => {
    return axiosInstance.get("/reports/appointments", { params });
  },

  getLabTestStats: (params) => {
    return axiosInstance.get("/reports/lab-tests", { params });
  },

  getRevenueStats: (params) => {
    return axiosInstance.get("/reports/revenue", { params });
  },

  getUserGrowthStats: (params) => {
    return axiosInstance.get("/reports/user-growth", { params });
  },

  exportToExcel: (reportType, params) => {
    return axiosInstance.get(`/reports/export/${reportType}`, {
      params,
      responseType: "blob",
    });
  },

  exportToPDF: (reportType, params) => {
    return axiosInstance.get(`/reports/export-pdf/${reportType}`, {
      params,
      responseType: "blob",
    });
  },
};

export const notificationAPI = {
  getAll: (params) => axiosInstance.get("/notifications", { params }),

  getUnreadCount: () => axiosInstance.get("/notifications/unread-count"),

  markAsRead: (id) => axiosInstance.put(`/notifications/${id}/read`),

  markAllAsRead: () => axiosInstance.put("/notifications/mark-all-read"),

  // No ids marks every notification read.
  markRead: (ids) => axiosInstance.put(`${API_ENDPOINTS.NOTIFICATIONS}/read`, ids ? { ids } : {}),

  delete: (id) => axiosInstance.delete(`/notifications/${id}`),

  clearAll: () => axiosInstance.delete("/notifications/clear-all"),
};

export const settingsAPI = {
  getSystemSettings: () => axiosInstance.get("/settings/system"),

  updateSystemSettings: (data) => axiosInstance.put("/settings/system", data),

  getEmailSettings: () => axiosInstance.get("/settings/email"),

  updateEmailSettings: (data) => axiosInstance.put("/settings/email", data),

  getPaymentSettings: () => axiosInstance.get("/settings/payment"),

  updatePaymentSettings: (data) => axiosInstance.put("/settings/payment", data),
};

export const pointsSettingAPI = {
  getSettings: () => axiosInstance.get(API_ENDPOINTS.POINTS_SETTINGS),

  updatePointsConfig: (data) =>
    axiosInstance.put(`${API_ENDPOINTS.POINTS_SETTINGS}/points`, data),

  addMilestone: (data) =>
    axiosInstance.post(`${API_ENDPOINTS.POINTS_SETTINGS}/milestones`, data),

  updateTransplantProgress: (targetPoints) => axiosInstance.put(`${API_ENDPOINTS.POINTS_SETTINGS}/transplant-progress`, { targetPoints }),
  updateMilestone: (milestoneId, data) =>
    axiosInstance.put(
      `${API_ENDPOINTS.POINTS_SETTINGS}/milestones/${milestoneId}`,
      data
    ),

  deleteMilestone: (milestoneId) =>
    axiosInstance.delete(
      `${API_ENDPOINTS.POINTS_SETTINGS}/milestones/${milestoneId}`
    ),

  getMilestones: async () => {
    const response = await axiosInstance.get(API_ENDPOINTS.POINTS_SETTINGS);
    return response.data.milestones || [];
  },

  getLabSlotSettings: () =>
    axiosInstance.get(`${API_ENDPOINTS.POINTS_SETTINGS}/lab-slots`),
  updateLabSlotSettings: (data) =>
    axiosInstance.put(`${API_ENDPOINTS.POINTS_SETTINGS}/lab-slots`, data),

  getProfileVerificationFee: () =>
    axiosInstance.get(`${API_ENDPOINTS.POINTS_SETTINGS}/profile-verification-fee`),
  updateProfileVerificationFee: (fee) =>
    axiosInstance.put(`${API_ENDPOINTS.POINTS_SETTINGS}/profile-verification-fee`, {
      profileVerificationFee: fee,
    }),
};

export const generalSettingsAPI = {
  getHomePageSettings: () => {
    return axiosInstance.get("/general-settings/home-page");
  },

  createBanner: (formData) => {
    return axiosInstance.post("/general-settings/banners", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  updateBanner: (bannerId, formData) => {
    return axiosInstance.put(
      `/general-settings/banners/${bannerId}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
  },

  deleteBanner: (bannerId) => {
    return axiosInstance.delete(`/general-settings/banners/${bannerId}`);
  },

  toggleBannerStatus: (bannerId, data) => {
    return axiosInstance.patch(
      `/general-settings/banners/${bannerId}/toggle`,
      data
    );
  },

  createQuickAction: (formData) => {
    return axiosInstance.post("/general-settings/quick-actions", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  updateQuickAction: (quickActionId, formData) => {
    return axiosInstance.put(
      `/general-settings/quick-actions/${quickActionId}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
  },

  deleteQuickAction: (quickActionId) => {
    return axiosInstance.delete(
      `/general-settings/quick-actions/${quickActionId}`
    );
  },

  toggleQuickActionStatus: (quickActionId, data) => {
    return axiosInstance.patch(
      `/general-settings/quick-actions/${quickActionId}/toggle`,
      data
    );
  },

  createPopularTest: (data) => {
    return axiosInstance.post("/general-settings/popular-tests", data);
  },

  updatePopularTest: (popularTestId, data) => {
    return axiosInstance.put(
      `/general-settings/popular-tests/${popularTestId}`,
      data
    );
  },

  deletePopularTest: (popularTestId) => {
    return axiosInstance.delete(
      `/general-settings/popular-tests/${popularTestId}`
    );
  },

  togglePopularTestStatus: (popularTestId, data) => {
    return axiosInstance.patch(
      `/general-settings/popular-tests/${popularTestId}/toggle`,
      data
    );
  },
};

export const dashboardAPI = {
  getCkdRevenue: params => axiosInstance.get("/dashboard/superadmin/ckd", { params }),

  getSuperAdminDashboard: (params) => {
    return axiosInstance.get("/dashboard/superadmin", { params });
  },

  getTodayAppointments: (params) => {
    return axiosInstance.get("/dashboard/superadmin/appointments/today", {
      params,
    });
  },

  getTodayLabTestBookings: (params) => {
    return axiosInstance.get("/dashboard/superadmin/lab-tests/today", {
      params,
    });
  },

  getRecentActivities: (params) => {
    return axiosInstance.get("/dashboard/superadmin/activities/recent", {
      params,
    });
  },

  getRevenueChartData: (params) => {
    return axiosInstance.get("/dashboard/superadmin/revenue/chart", {
      params,
    });
  },


  getLabAdminDashboard: () => {
    return axiosInstance.get("/dashboard/labadmin");
  },

  getLabAdminTodayBookings: (params) => {
    return axiosInstance.get("/dashboard/labadmin/bookings/today", {
      params,
    });
  },


  getDoctorDashboard: () => {
    return axiosInstance.get("/dashboard/doctor");
  },

  getDoctorTodayAppointments: (params) => {
    return axiosInstance.get("/dashboard/doctor/appointments/today", {
      params,
    });
  },
};
export const patientAPI = {
  getByUserId: (userId) => axiosInstance.get(`/patients/user/${userId}`),
};

export const doctorSettingsAPI = {
  getSettings: () => axiosInstance.get("/doctor-settings"),
  addSpecialty: (name) => axiosInstance.post("/doctor-settings/specialties", { name }),
  removeSpecialty: (name) => axiosInstance.delete(`/doctor-settings/specialties/${encodeURIComponent(name)}`),
  addCategory: (name) => axiosInstance.post("/doctor-settings/categories", { name }),
  removeCategory: (name) => axiosInstance.delete(`/doctor-settings/categories/${encodeURIComponent(name)}`),
  addQualification: (name) => axiosInstance.post("/doctor-settings/qualifications", { name }),
  removeQualification: (name) => axiosInstance.delete(`/doctor-settings/qualifications/${encodeURIComponent(name)}`),
  addLabTestCategory: (name) => axiosInstance.post("/doctor-settings/lab-test-categories", { name }),
  removeLabTestCategory: (name) => axiosInstance.delete(`/doctor-settings/lab-test-categories/${encodeURIComponent(name)}`),
  updateReferralPoints: (points) => axiosInstance.put("/doctor-settings/referral-points", { points }),
};

export const policyAPI = {
  get: () => axiosInstance.get("/policy"),
  upsert: (data) => axiosInstance.put("/policy", data),
  getAcceptances: (params) => axiosInstance.get("/policy/acceptances", { params }),
};

export default {
  auth: authAPI,
  user: userAPI,
  appointment: appointmentAPI,
  lab: labAPI,
  labTest: labTestAPI,
  labPartner: labPartnerAPI,
  testBooking: testBookingAPI,
  upload: uploadAPI,
  report: reportAPI,
  notification: notificationAPI,
  settings: settingsAPI,
};

export const rewardsAPI = {
  getClaims: params => axiosInstance.get('/rewards/claims', { params }),
  updateClaim: (id, data) => axiosInstance.put(`/rewards/claims/${id}`, data),
};

export const doctorApplicationAPI = {
  create: data => axiosInstance.post(`${API_ENDPOINTS.DOCTOR_APPLICATIONS}/admin/register`, data),
  save: (id, data) => axiosInstance.put(`${API_ENDPOINTS.DOCTOR_APPLICATIONS}/${id}`, data),
  upload: (id, kind, data) => axiosInstance.post(`${API_ENDPOINTS.DOCTOR_APPLICATIONS}/${id}/documents/${kind}`, data),
  list: params => axiosInstance.get(API_ENDPOINTS.DOCTOR_APPLICATIONS, { params }),
  review: (id, data) => axiosInstance.post(`${API_ENDPOINTS.DOCTOR_APPLICATIONS}/${id}/review`, data),
  document: (id, kind) => axiosInstance.get(`${API_ENDPOINTS.DOCTOR_APPLICATIONS}/${id}/documents/${kind}`, { responseType: 'blob' }),
  retry: (id, channel) => axiosInstance.post(`${API_ENDPOINTS.DOCTOR_APPLICATIONS}/${id}/notifications/${channel}/retry`),
};
